"use client";

import { motion } from "framer-motion";
import { MapPin, Star } from "lucide-react";
import DownloadCTA from "@/components/shared/DownloadCTA";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function ContactSection() {
  return (
    <section id="contact" className="cv-auto bg-paper border-t border-line py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-24 items-start">

          {/* Left: direct contact */}
          <motion.div
            variants={stagger(0.09)}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            className="flex flex-col gap-6"
          >
            <motion.p
              variants={fadeUp}
              className="flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-ink-faint"
            >
              <span className="w-1.5 h-1.5 bg-accent shrink-0" aria-hidden="true" />
              Kontakt
            </motion.p>

            <motion.h2
              variants={fadeUp}
              className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.1] text-ink"
            >
              Noch Fragen?
            </motion.h2>

            <motion.p variants={fadeUp} className="text-ink-soft text-lg leading-relaxed max-w-md">
              Du hast Fragen, Feedback oder Verbesserungsvorschläge? Wir freuen
              uns von dir zu hören.
            </motion.p>

            <motion.div variants={fadeUp} className="pt-2">
              <a
                href="mailto:info@ncrechner.de"
                className="font-display font-bold text-2xl sm:text-3xl text-ink underline decoration-accent decoration-2 underline-offset-8 hover:text-accent transition-colors duration-200 cursor-pointer break-all"
              >
                info@ncrechner.de
              </a>
            </motion.div>

            <motion.p variants={fadeUp} className="flex items-start gap-2.5 text-sm text-ink-faint pt-4">
              <MapPin size={15} className="shrink-0 mt-0.5" aria-hidden="true" />
              <span>
                futuredoctor GmbH
                <br />
                Bettinastraße 62, 60325 Frankfurt am Main
              </span>
            </motion.p>
          </motion.div>

          {/* Right: app download */}
          <motion.div
            variants={stagger(0.09)}
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            className="rounded-3xl bg-accent text-paper p-8 sm:p-10 flex flex-col gap-6"
          >
            <motion.p
              variants={fadeUp}
              className="text-xs font-bold uppercase tracking-widest text-paper/60"
            >
              App laden
            </motion.p>
            <motion.h3
              variants={fadeUp}
              className="font-display font-bold text-2xl sm:text-3xl tracking-tight leading-[1.1]"
            >
              Berechne deine Chancen direkt in der App.
            </motion.h3>
            <motion.p variants={fadeUp} className="text-paper/80 leading-relaxed">
              Kostenlos für iOS und Android. Keine Anmeldung, keine versteckten
              Kosten.
            </motion.p>
            <motion.p variants={fadeUp} className="flex items-center gap-2 text-sm text-paper/80">
              <span className="flex items-center gap-0.5" aria-hidden="true">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={13} className="fill-paper text-paper" />
                ))}
              </span>
              <span className="tnum">4,8 Sterne</span>
            </motion.p>
            <motion.div variants={fadeUp} className="pt-1">
              <DownloadCTA variant="paper" />
            </motion.div>
          </motion.div>

        </div>
      </div>
    </section>
  );
}
